import React from 'react';
import styled from "styled-components"
import TBHeroCurrency from "../Commons/HeroCurrency";
import ThreeDotLoader from "../Commons/Loaders/ThreeDotLoader.react";
import { formatNumber} from "../../Utilities/utilities";
import {Area, AreaChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

const StyledOverview = styled.div`
  height: 52.6rem;
  width: 100%;
  
  .totals {
    display: flex;
    justify-content: space-between;
    width: 100%;
    
    .account-balance,
    .total-transactions,
    .new-customers {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 1rem;
      padding-bottom: 1rem;
      
      h5 {
        font-size: 2rem;
        font-weight: 200;
        padding-top: 1rem;
      }
      
      h3 {
        font-size: 3.2rem;
        margin: .2rem;
      }
    }
    
    .account-balance {
      //width: 120rem;
      width: 50%;
      background-color: white;
    }
    
    .total-transactions, .new-customers {
      border: 1px solid white;
      width: 50%;
      color: white;
    }
    
    .divider {
      width: 2rem;
      border: 1px solid #3388BD;
    }
  }
  
  .graph {
    background-color: white;
    height: 36rem;
    padding: 2.5rem 3rem;
  }
`
// USD Volume
// Fee Revenue
// Realized Gain/Loss
// Unrealized Gain / Loss

const fakeData = [
  {
    "date": "Jan 1",
    "This Week": 2000,
    "Last Week": 2400,
    "amt": 2400
  },
  {
    "date": "Jan 2",
    "This Week": 2200,
    "Last Week": 3398,
    "amt": 2210
  },
  {
    "date": "Jan 3",
    "This Week": 3900,
    "Last Week": 3400,
    "amt": 2290
  },
  {
    "date": "Jan 4",
    "This Week": 7780,
    "Last Week": 3908,
    "amt": 2000
  },
  {
    "date": "Jan 5",
    "This Week": 5990,
    "Last Week": 5100,
    "amt": 2181
  },
  {
    "date": "Jan 6",
    "This Week": 5290,
    "Last Week": 5900,
    "amt": 2500
  },
  {
    "date": "Jan 7",
    "This Week": 7440,
    "Last Week": 7980,
    "amt": 2100
  }
]

const ReportOverview = ({customers='NA', transactions='NA', loading=false}) => {
  return (
    <StyledOverview>
      <div className={'totals'}>
        <div className={'account-balance'}>
          {
            loading ?
              <ThreeDotLoader/> :
              <>
                <TBHeroCurrency stat={'$8,372,012.32'} />
                <h5>USD Volume</h5>
              </>
          }
        </div>
        <div className={'divider'} />
        <div className={'new-customers'}>
          {
            customers == 'NA' ?
              <ThreeDotLoader /> :
              <>
                <h3>{formatNumber(customers)}</h3>
                <h5>Fee Revenue</h5>
                {/*<h5>New Customers</h5>*/}
              </>
          }

        </div>
        <div className={'divider'} />
        <div className={'total-transactions'}>
          {
            transactions == 'NA' ?
              <ThreeDotLoader /> :
              <>
                <h3>{formatNumber(transactions)}</h3>
                <h5>Realized Gain / Loss</h5>
                {/*<h5>Transactions</h5>*/}
              </>
          }

        </div>
        <div className={'divider'} />
        <div className={'total-transactions'}>
          {
            transactions == 'NA' ?
              <ThreeDotLoader /> :
              <>
                <h3>{formatNumber(transactions)}</h3>
                <h5>Unrealized Gain / Loss</h5>
              </>
          }

        </div>
      </div>
      <div className={'graph'}>
        <ResponsiveContainer width={'100%'}>
          <AreaChart width={300} height={250} data={fakeData}
                     margin={{ top: 10, right: 10, left: 10, bottom: 22 }}>
            <defs>
              <linearGradient id="colorPastStat" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#E8E8E8" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#E8E8E8" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorCurrentStat" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#D1E6F3" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#D1E6F3" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <XAxis
              tickLine={false}
              axisLine={false}
              padding={{left: 20, right: 20}}
              dataKey="date"
              tickMargin={17}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              tickFormatter={number => `$${number}k`}
            />
            {/*CartesianGrid grid is the lines*/}
            <CartesianGrid opacity={0.5} vertical={false} />
            <Tooltip />
            <Area type="monotone" dataKey="This Week" stroke="#0E7CBF" fillOpacity={1} fill="url(#colorCurrentStat)" />
            <Area type="monotone" dataKey="Last Week" stroke="#7E7E7E" fillOpacity={1} fill="url(#colorPastStat)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </StyledOverview>
  )
}

export default ReportOverview;